<script setup>
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { BSpinner } from 'bootstrap-vue-next';
  import { removeUserAccess } from '../services/UsersService';

  // FBKS-4003: removes the user's access to one library/network/retailer only --
  // the account and its other accesses are kept.
  const { t } = useI18n();
  const i18nScope = ref('components.users_management');
  // showToast also refreshes the list.
  const emits = defineEmits(['closeModal', 'showToast']);

  const props = defineProps({
    user: {
      type: Object,
      required: true
    },
    // { role, params: { library_id | network_id | retailer_id }, name }
    organisation: {
      type: Object,
      required: true
    }
  });

  const loading = ref(false);

  const removeAccessNow = async () => {
    loading.value = true;
    try {
      await removeUserAccess(props.user.id, { role: props.organisation.role, ...props.organisation.params });
      emits('showToast', { type: 'success', message: 'remove_access_success' });
    } catch (error) {
      // Refusals retrying can't fix get their own message.
      const refusals = {
        unauthorized_organisation: 'remove_access_unauthorized',
        cannot_remove_own_access: 'remove_access_own',
        cannot_remove_staff_access: 'remove_access_staff',
        last_admin: 'remove_access_last_admin'
      };
      emits('showToast', { type: 'error', message: refusals[error.response?.data?.error] || 'remove_access_error' });
    } finally {
      loading.value = false;
      emits('closeModal');
    }
  };
</script>

<template>
  <form>
    <h4>{{ t(`${i18nScope}.remove_access_confirm`, { user: props.user.fullName || props.user.username, organisation: props.organisation.name }) }}</h4>
    <p>{{ t(`${i18nScope}.remove_access_keeps_account`) }}</p>
    <br>

    {{ props.user?.fullName }}<br>
    {{ props.user?.mail }}<br>
    <br>

    <hr>

    <div class="d-flex gap-2 mt-4" v-if="!loading">
      <button type="button" class="btn btn-danger" @click.prevent="removeAccessNow">
        {{ t(`${i18nScope}.remove_access`) }}
      </button>
      <button type="button" class="btn btn-outline-secondary" @click.prevent="emits('closeModal')">
        {{ t(`${i18nScope}.user_details.cancel`) }}
      </button>
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <BSpinner style="width: 3rem; height: 3rem;" variant="primary" v-if="loading" />
    </div>
  </form>
</template>
